import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'lodash';

const fn = ($scope, StateUtils, claimViewModel, TranslateService, ViewModelService) => {
    const ctrl = Object.create(BaseCtrl);
    const flowModel = StateUtils.activeDataForState(true).flowModel;

    ctrl.init = () => {
        const claimVm = claimViewModel();
        $scope.claimSubmitCtxModel = ViewModelService.create(claimVm.value, 'cc', 'edge.capabilities.claim.fnol.dto.FnolDTO', { 'SubmittingClaim': true });
        $scope.showSecondaryContact = _.get($scope.claimSubmitCtxModel, 'mainContact.secondaryContact_PSA.firstName.value', false);
    };

    ctrl.toggleAddRemoveSecondaryContact = () => {
        if ($scope.showSecondaryContact) {
            $scope.claimSubmitCtxModel.mainContact.secondaryContact_PSA.value = null;
            $scope.showSecondaryContact = false;
        } else {
            $scope.claimSubmitCtxModel.mainContact.secondaryContact_PSA.value = { subtype: 'Person' };
            $scope.showSecondaryContact = true;
        }
    };

    ctrl.next = function (form) {
        form.submitted = true;
        if (!form.valid) {
            return;
        }
        flowModel.next($scope.claimSubmitCtxModel);
    };

    ctrl.previous = function () {
        flowModel.previous($scope.claimSubmitCtxModel);
    };

    ctrl.cancel = function () {
        flowModel.cancel($scope.claimSubmitCtxModel);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils', 'claimViewModel', 'TranslateService', 'ViewModelService'];

export default fn;
